import styled, { css } from 'styled-components';
import { LocalizeTextProps, Substitutes, useLocalizeText } from './useLocalizeText';

/**
 * we only allow formatting rich text through the component,
 * doing it directly in the hook would mess up the return types
 */

type AllowedSubstitutes = string | number | JSX.Element;
export type RichSubstitutes = Record<
    string,
    AllowedSubstitutes | ((parts: AllowedSubstitutes | AllowedSubstitutes[]) => AllowedSubstitutes)
>;

interface Formatters {
    /** @deprecated doesn't work across languages, create a new translation key */
    firstLowerCase?: boolean;
    /** @deprecated doesn't work across languages, create a new translation key */
    lowerCase?: boolean;
    upperCase?: boolean;
}

const StyledSpan = styled.span<Formatters>`
    ${({ lowerCase }) => lowerCase && 'text-transform: lowercase;'}
    ${({ upperCase }) => upperCase && 'text-transform: uppercase;'}
    ${({ firstLowerCase }) =>
        firstLowerCase &&
        css`
            display: inline-block;
            &::first-letter {
                text-transform: lowercase;
            }
        `}
`;

export interface LocalizedTextProps extends LocalizeTextProps<RichSubstitutes>, Formatters {}

export const LocalizedText = ({
    textKey,
    substitutes,
    lowerCase,
    firstLowerCase,
    upperCase,
    ...other
}: LocalizedTextProps) => {
    const hasSubstitutes = substitutes != null && Object.keys(substitutes).length > 0;

    return (
        <StyledSpan
            {...other}
            data-test-textkey={textKey}
            data-non-sensitive={!hasSubstitutes ? true : undefined}
            lowerCase={lowerCase}
            upperCase={upperCase}
            firstLowerCase={firstLowerCase}
        >
            {useLocalizeText()({ textKey, substitutes: substitutes as Substitutes })}
        </StyledSpan>
    );
};
